import React from 'react';
import { Flex, Icon, Label } from '@zeal/web-ui';
import { Trans, useTranslation } from 'react-i18next';

export function NotificationsEmpty() {
	const { t } = useTranslation('common');

	return (
		<Flex className="h-full" align="center" justify="center">
			<Flex
				isColumn
				gap="3"
				align="center"
				justify="center"
				style={{
					maxWidth: '240px',
				}}
			>
				<Icon
					iconName="bellSlash"
					variant="regular"
					colorVariant="subdued"
					size="2x"
				/>
				<Flex isColumn gap="2">
					<Label.Mid300 textAlign="center">
						{t('notifications_empty_title')}
					</Label.Mid300>
					<Label.Thin200 textAlign="center" variant="subdued">
						<Trans
							t={t}
							i18nKey="notifications_empty_subtitle"
							components={{
								line_break: <br />,
							}}
						/>
					</Label.Thin200>
				</Flex>
			</Flex>
		</Flex>
	);
}
